import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	isUnchangeable: ForNodeType<boolean>;
	onSetIsUnchangeable: (value: boolean) => void;
};

export const QuestionPlanIsUnchangeable = ({ isUnchangeable, onSetIsUnchangeable }: Props) => {
	const label = "予約内容の変更ができないプラン";
	const guide = "予約の日程やオプションの変更ができないプランを作成できます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isUnchangeable.isEdited}
			hasError={Boolean(isUnchangeable.error)}
			inputChildren={
				<CheckboxField
					value={isUnchangeable.value}
					label={"変更できないプランにする"}
					handleChange={onSetIsUnchangeable}
					errorMessage={isUnchangeable.error}
				/>
			}
		/>
	);
};

QuestionPlanIsUnchangeable.displayName = "QuestionPlanIsUnchangeable";
